<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col v-bind:class="{'mt-md-n10': !noMarginTop}" class="pt-0" cols="12" :md="stackedView ? 12 : 4" :order="stackedView ? 3 : 2">
        <MediaModeForm v-if="(currentUser.clientType === 'Media' || currentUser.clientType === 'Driblab') && !stackedView" :fields="mediaModeFields"
        :mediaMode="mediaMode" @mediaModeChange="mediaMode = $event"
        :mediaModeData="mediaModeData" @mediaModeDataChange="onMediaModeDataChange($event)"
        :mediaModeFlags="mediaModeFlags" @mediaModeFlagsChange="mediaModeFlags = $event" selectorMode></MediaModeForm>
        <v-card class="pb-2" elevation="0" outlined>
          <v-row id="team-radar-season" class="mx-0 pt-2">
            <v-col cols="12" class="py-1">
              <v-card-title class="pa-0 header-font pt-2" style="font-size: 22px;">{{ $t('general.filters') }}</v-card-title>
            </v-col>
            <!--Seasons-->
            <v-col cols="12" md="8" class="py-0">
              <v-card-text class="pa-0 mb-3" id="season-selection">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1 mt-2">{{ $t('table.clientLeagues.seasons') }}</p>
                <v-autocomplete v-if="teamSeasons.length" class="pa-0 mt-2 mb-3" multiple dense hide-details clearable
                  :items="teamSeasons"
                  v-model="seasonDataSelectedModel"
                  item-value="seasonId"
                  item-text="seasonName"
                  @change="onSeasonChange()"
                >
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text" v-if="index <= 2">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`" type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="font-weight-bold">{{item.seasonName}}</span>
                    </v-chip>
                    <span v-if="index === 3"
                          class="primary--text body-2 subheader-font"
                        >(+{{ seasonDataSelectedModel.length - 3 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <v-card-text
                      class="pa-0 primary--text font-weight-medium d-flex align-center"
                    >
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`" type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="d-flex flex-column">
                        {{item.seasonName}}
                      </span>
                    </v-card-text>
                  </template>
                </v-autocomplete>
                <v-skeleton-loader v-else type="text" class="mt-3 w-100" width="200"></v-skeleton-loader>
              </v-card-text>
            </v-col>
            <!--Filter Games-->
            <v-col cols="12" md="4" class="py-1">
              <v-card-text class="pa-0 mb-3">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1 mt-2">{{ $t('searchbar.games') }}</p>
                <v-autocomplete class="pa-0 mt-2 mb-3" hide-details dense clearable
                  v-model="groundModel"
                  :items="grounds"
                  item-text="name"
                  item-value="id"
                  @change="onSelectChange()"
                >
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 w-80 d-flex justify-center black--text">
                      <span class="body-2 text-ellipsis">{{item.name}}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{item}">
                    <span class="body-2">{{item.name}}</span>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <!--Games-->
            <v-col cols="12" class="py-0">
              <v-skeleton-loader type="text" class="mt-3" v-if="!gamesFiltered.length"></v-skeleton-loader>
              <v-card-text class="pa-0 flex-shrink-1" v-if="gamesFiltered.length">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('searchbar.games') }}</p>
                <v-autocomplete multiple menu-props="auto" hide-details dense clearable class="pa-0 body-2 mb-2"
                  v-model="gamesModel"
                  :items="gamesFiltered"
                  item-text="name"
                  item-value="gameId"
                  @blur="updateShots()"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggleGames">
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="body-2">{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text" v-if="index <= 0">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`" type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="body-2 text-ellipsis">{{item.name}}</span>
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`" type="image/png" height="20" class="ml-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                    </v-chip>
                    <span v-if="index === 1" class="primary--text body-2 subheader-font">(+{{ gamesModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`" type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="body-2">{{item.name}}</span>
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`" type="image/png" height="20" class="ml-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <v-row class="mx-0 mt-1">
            <!--Team-->
            <v-col cols="12" class="py-0">
              <v-card-text class="pa-0" id="own-opponent">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1 my-2">{{ $t('table.history.team') }}</p>
                <v-radio-group row background-color="transparent" hide-details class="ma-0 pa-0"
                  v-model="shotsModel"
                  @change="updateShots()"
                >
                  <v-radio color="secondary" value="team">
                    <template v-slot:label>
                      <span class="body-1 primary--text">{{ teamInfo.teamName }}</span>
                    </template>
                  </v-radio>
                  <v-radio color="secondary" value="opponent">
                    <template v-slot:label>
                      <span class="body-1 primary--text">{{ $t('general.opponent') }}</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Display type-->
          <v-row class="mx-0 mt-1">
            <v-col cols="12" md="8" class="py-0">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1 my-2">{{ $t('general.displayType') }}</p>
              <v-radio-group v-model="selectedTab" row mandatory hide-details class="ma-0 pa-0" @change="onTypeChange($event)" v-if="showGoalChart">
                <!--Pitch-->
                <v-radio color="secondary" value="topView">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('playerDetail.placer') }}<v-icon small class="ms-1">border_horizontal</v-icon></span>
                  </template>
                </v-radio>
                <!--Goal-->
                <v-radio color="secondary" value="frontView">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('general.goal') }}<v-icon small class="ms-1">airplay</v-icon></span>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <!--Show options-->
          <v-card-text class="d-flex pb-2 pl-0 justify-center" cols="12" v-if="$vuetify.breakpoint.smAndDown">
            <v-btn color="primary" class="monospace-font px-4" small outlined rounded @click="showShotOptions = !showShotOptions">
              {{ showShotOptions ? $t('game.detail.hideShotOptions') : $t('game.detail.showShotOptions')}} <v-icon right > {{ showShotOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
            </v-btn>
          </v-card-text>
          <!--Penalties-->
          <v-row class="mx-0  mt-1" v-if="showShotOptions">
            <v-col class="py-1" cols="12" sm="12" v-if="showShotOptions && hasPenalties">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1 mt-1">{{ $t('game.detail.penalties') }}</p>
              <v-card-text class="pa-0 ma-0 d-flex" id="shot-placement">
                <v-checkbox
                  v-if="penalties.length"
                  v-model="showPenalties"
                  :label="$t('finishingMap.penalty')"
                  color="secondary"
                  hide-details
                  class="pa-0 my-2 me-3"
                  @change="updateShots()"
                >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('finishingMap.penalty') }}</span>
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-if="penaltiesShootout.length"
                  v-model="showShootoutPenalties"
                  :label="$t('finishingMap.penaltyShootout')"
                  color="secondary"
                  hide-details
                  class="pa-0 my-2"
                  @change="updateShots()"
                >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('finishingMap.penaltyShootout') }}</span>
                  </template>
                </v-checkbox>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Visualization-->
          <v-row class="mx-0" v-if="showShotOptions">
            <v-col cols="12" class="py-1">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('team.visualization') }}</p>
              <v-card-text class="pa-0 ma-0 d-flex" id="shot-placement">
                <v-checkbox dense hide-details color="secondary" class="pa-0 my-2 me-3"
                  v-model="checkboxCircles"
                  @change="updateShots()"
                  value="circles"
                >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('finishingMap.circles') }}</span>
                  </template>
                </v-checkbox>
                <v-checkbox dense hide-details color="secondary" class="pa-0 my-2"
                  v-model="checkboxCircles"
                  @change="updateShots()"
                  value="boxes"
                >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('finishingMap.boxes') }}</span>
                  </template>
                </v-checkbox>
              </v-card-text>
              <div class="d-flex align-center mt-2" v-if="checkboxCircles.includes('boxes')">
                <span class="mr-2 v-label cursor-pointer mt-1 primary--text body-1" @click="showAllInfoInBoxes = !showAllInfoInBoxes; updateShots()"
                >{{ $t('finishingMap.onlyPercentage') }}</span>
                <v-switch
                  v-model="showAllInfoInBoxes"
                  ref="showAllInfoInBoxes"
                  hide-details
                  color="secondary"
                  class="ma-0 primary--text body-1"
                  @change="updateShots"
                >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('finishingMap.showAll') }}</span>
                  </template>
                </v-switch>
              </div>
            </v-col>
          </v-row>
          <!--Metrics-->
          <v-row class="mx-0" v-if="showShotOptions">
            <v-col cols="12" class="py-1">
              <v-card-text class="pa-0 mb-2">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1 mb-1">
                  {{ $t('general.metrics') }}
                  <v-tooltip top color="lightSecondary lighten-4" max-width="300" v-if="!checkboxCircles.includes('boxes')">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon x-small color="secondary" v-on="on" v-bind="attrs">info</v-icon>
                    </template>
                    <span class="black--text body-1">{{ $t('disabledTooltips.selectBoxes') }}</span>
                  </v-tooltip>
                </p>
                <v-radio-group row background-color="transparent" hide-details class="ma-0 pa-0"
                  v-model="boxesPercentageModel"
                  @change="updateShots()"
                  :disabled="!checkboxCircles.includes('boxes')"
                >
                  <v-radio color="secondary" value="shots">
                    <template v-slot:label>
                      <span class="body-1 primary--text">{{ $t('statsNaming.Shots') }}</span>
                    </template>
                  </v-radio>
                  <v-radio color="secondary" value="xg">
                    <template v-slot:label>
                      <span class="body-1 primary--text">xG</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Shot area-->
          <v-row class="mx-0 mb-2" v-if="showShotOptions && selectedTab === 'topView'">
            <v-col cols="12" class="pt-1 pb-0">
              <v-card-text class="pa-0">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.areas') }}</p>
                <v-btn small @click="onSelectAreaClick()" rounded class="elevation-0 monospace-font white--text px-2 my-1" color="secondary">
                  <v-icon color="white" x-small>filter_list</v-icon>
                  <span class="ms-1">{{ `${$t('areaSelector.filterAreas')} (${areaModel.length}/16)` }}</span>
                </v-btn>
                <AreaSelectorModal 
                  ref="areaSelectorModalRef" 
                  v-if="teamInfo"
                  :title="`${$t('playerDetail.finishingMap')} - ${$t('areaSelector.selectAreas')}`"
                  :areaModel="areaModel"
                  :isVertical="true"
                  @onConfirmClick="onAreaSelectorConfirm($event)"
                ></AreaSelectorModal>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Goal area-->
          <v-row class="mx-0 mb-2" v-if="showShotOptions && selectedTab === 'frontView'">
            <v-col cols="12" class="py-0 pb-0">
              <v-card-text v-if="selectedTab === 'frontView'" class="pa-0">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.areas') }}</p>
                <v-btn small @click="onSelectGoalAreaClick()" rounded class="elevation-0 monospace-font white--text px-2 my-1" color="secondary">
                  <v-icon color="white" x-small>filter_list</v-icon>
                  <span class="ms-1">{{ `${$t('areaSelector.filterAreas')} (${goalAreaModel.length}/14)`  }}</span>
                </v-btn>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Types of shot-->
          <v-row class="mx-0 mt-1 mb-2" v-if="showShotOptions">
            <v-col cols="12" class="pt-1 pb-0">
              <v-card-text class="pa-0" id="shot-type">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.typesOfShot') }}</p>
                <v-autocomplete multiple hide-details dense clearable class="pa-0"
                  v-model="shotTypeModel"
                  :items="shotTypes"
                  item-text="text"
                  item-value="id"
                  @change="updateShots()"
                >
                  <v-list-item slot="prepend-item" ripple @click="toggleShotTypes">
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider slot="prepend-item" class="mt-2"></v-divider>
                  <template v-slot:selection="{item,index}">
                    <v-chip v-if="index === 0" small color="lightSecondary lighten-2" class="my-1">
                      <span class="black--text">&nbsp;{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="primary--text body-2 subheader-font">(+{{ shotTypeModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <span class="body-2 primary--text">{{item.text}}</span>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Shot strategy-->
          <v-row class="mx-0 mb-2" v-if="showShotOptions">
            <v-col cols="12" class="pt-1 pb-0">
              <v-card-text class="pa-0">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.shotStrategy') }}</p>
                <v-autocomplete multiple hide-details dense clearable class="pa-0"
                  v-model="shotStrategyModel"
                  :items="shotStrategies"
                  item-text="text"
                  item-value="id"
                  @change="updateShots()"
                >
                  <v-list-item slot="prepend-item" ripple @click="toggleShotStrategies">
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider slot="prepend-item" class="mt-2"></v-divider>
                  <template v-slot:selection="{item,index}">
                    <v-chip v-if="index === 0" small color="lightSecondary lighten-2" class="my-1">
                      <span class="black--text">&nbsp;{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="primary--text body-2 subheader-font">(+{{ shotStrategyModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <span class="body-2 primary--text">{{item.text}}</span>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Body Parts-->
          <v-row class="mx-0 mb-2" v-if="showShotOptions">
            <v-col cols="12" class="pt-1 pb-0">
              <v-card-text class="pa-0">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.bodyPart') }}</p>
                <v-autocomplete multiple hide-details dense clearable class="pa-0"
                  v-model="bodyPartModel"
                  :items="bodyParts"
                  item-text="text"
                  item-value="id"
                  @change="updateShots()"
                >
                  <v-list-item slot="prepend-item" ripple @click="toggleBodyPart">
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider slot="prepend-item" class="mt-2"></v-divider>
                  <template v-slot:selection="{item,index}">
                    <v-chip v-if="index === 0" small color="lightSecondary lighten-2" class="my-1">
                      <span class="black--text">&nbsp;{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="primary--text body-2 subheader-font">(+{{ bodyPartModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <span class="body-2 primary--text">{{item.text}}</span>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Minutes-->
          <v-row class="mx-0" v-if="showShotOptions">
            <v-col cols="12" class="py-1">
              <v-card-text class="pa-0" id="filter-minutes">
                <v-range-slider step="1" hide-details :color="`secondary ${$vuetify.theme.dark ? 'lighten-3' : ''}`"
                  class="align-center py-0"
                  thumb-label
                  :label="$t('finishingMap.minutes')"
                  v-model="minutes"
                  :min="rangeMinutes[0]"
                  :max="rangeMinutes[1]"
                  @input="updateShots"
                >
                  <template v-slot:label>
                    <div class="d-flex flex-column">
                      <span class="primary--text font-weight-bold body-1">{{ $t('finishingMap.minutes') }}</span>
                      <span class="body-2 subheader-font monospace-font">{{ `(${rangeMinutes[0]} - ${rangeMinutes[1]})` }}</span>
                    </div>
                  </template>
                </v-range-slider>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Download actions-->
          <div v-if="!stackedView" class="pb-2 px-1 mt-5">
            <v-divider></v-divider>
          </div>
          <div v-if="!stackedView" class="d-flex justify-end py-0 w-100 pr-1" id="image-download">
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" v-on:click.native="saveAsPNG()">
              <v-icon small class="mr-1">file_download</v-icon>
              <span class="">PNG</span>
            </v-btn>
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" v-on:click.native="saveAsSVG()">
              <v-icon small class="mr-1">file_download</v-icon>
              <span>SVG</span>
            </v-btn>
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" :loading="loadingExport" v-on:click.native="onGenerateIFrameClick()">
              <v-icon small class="mr-1">share</v-icon>
              <span>Embed</span>
            </v-btn>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" :md="stackedView ? 12 : 8" id="chart" ref="chart"
        class="text-center pa-0" :order="stackedView ? 1 : 2" v-bind:class="{'py-0':stackedView}">
        <PlayerAvatarMedia v-if="avatarSize && mediaMode"
          :width="selectedTab === 'topView' && !fullSize ? size : size * 1.25" :height="selectedTab === 'topView' ? avatarSize.height : avatarSize.height * 1.25 "
          :id="`${teamInfo.teamId}-${chartId}`"
          :margin="margin" :title="mediaModeData.upperText" :subtitle="mediaModeData.lowerText"
          :color="mediaModeData.borderColor" ref="playerAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :face="mediaModeData.face ? mediaModeData.face.dataUrl : null" type="finishingMap" :orientation="mediaModeData.orientation ? mediaModeData.orientation : 'left'"
          class="" :lineDistance="mediaModeData.lineLength" :avatarSize="mediaModeData.avatarSize" :lineWeight="mediaModeData.lineWeight"
          :upperTextFontSize="mediaModeData.upperTextFontSize" :upperTextFontWeight="mediaModeData.upperTextFontWeight"
          :lowerTextFontSize="mediaModeData.lowerTextFontSize" :lowerTextFontWeight="mediaModeData.lowerTextFontWeight"
          :player="{}"
          :team="teamInfo"
          :teamMode="true"
          ></PlayerAvatarMedia>
        <XGChart
          v-if="size != 0 && shots.length > 0 && selectedTab === 'topView'"
          :id="`${teamInfo.teamId}-${chartId}`"
          :size="fullSize ? size * 1.25 : size"
          :shots="filteredShots"
          :circlesAndBoxes="checkboxCircles"
          :key="xgMap"
          :playerSeasonData="filteredSeasons"
          :playerName="teamInfo.teamName"
          :language="currentUserLanguage"
          :homeFillColor="mediaModeData.homeFillColor"
          :homeBorderColor="mediaModeData.homeBorderColor"
          :awayFillColor="mediaModeData.awayFillColor"
          :awayBorderColor="mediaModeData.awayBorderColor"
          :mediaMode="mediaMode"
          :gameIds="gameIds.length ? gameIds : gamesModel"
          :team="true"
          :teamOrOpponent="shotsModel === 'team'"
          :boxesPercentage="boxesPercentageModel"
          ref="xgChart"
          @sizeChange="onChartSizeChange($event)"
          @loaded="onLoaded($event)"
          :showPenalties="showPenalties || showShootoutPenalties"
          :showAllInfoInBoxes="showAllInfoInBoxes"
        />
        <XGGoalChart
          v-if="size != 0 && shots.length > 0 && selectedTab === 'frontView'"
          :id="`${teamInfo.teamId}-${chartId}`"
          :size="size * 1.25"
          :shots="filteredShots"
          :circlesAndBoxes="checkboxCircles"
          :key="xgMap"
          :playerSeasonData="filteredSeasons"
          :playerName="teamInfo.teamName"
          :team="true"
          :language="currentUserLanguage"
          :homeFillColor="mediaModeData.homeFillColor"
          :homeBorderColor="mediaModeData.homeBorderColor"
          :awayFillColor="mediaModeData.awayFillColor"
          :awayBorderColor="mediaModeData.awayBorderColor"
          :mediaMode="mediaMode"
          :gameIds="gameIds.length ? gameIds : gamesModel"
          ref="xgChart"
          @sizeChange="onChartSizeChange($event)"
          @loaded="onLoaded($event)"
          :showPenalties="showPenalties || showShootoutPenalties"
        />
        <DriblabSocialMedia v-if="avatarSize && size && mediaMode && mediaModeData.socialMedia"  :player="{}"
          :width="selectedTab === 'topView' && !fullSize ? size : size * 1.25" :height="50" :id="`${teamInfo.teamId}-${chartId}`"
          :margin="margin" ref="driblabSocialMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :fontSize="mediaModeData.socialMediaFontSize" :fontWeight="mediaModeData.socialMediaFontWeight"
          :logoCfg="mediaModeData.logo" :sponsor="mediaModeData.sponsor.dataUrl" type="finishingMap"></DriblabSocialMedia>

        <!--Loading field progress bar-->
        <div v-if="!shots.length" cols="12" class="text-center d-flex align-center justify-center mt-10">
          <v-progress-circular :size="75" color="secondary" indeterminate></v-progress-circular>
        </div>
      </v-col>
    </v-row>
    <!--Goal area selector-->
    <AreaSelectorModal 
      ref="goalAreaSelectorModalRef" 
      :title="`${$t('playerDetail.finishingMap')} - ${$t('areaSelector.selectAreas')}`"
      :areaModel="goalAreaModel"
      :isGoal="true"
      @onConfirmClick="onGoalAreaSelectorConfirm($event)"
    ></AreaSelectorModal>
    <ChartExportLinksModal ref="chartExportLinksModalRef" :title="teamInfo.teamName" v-if="teamInfo"
    :subtitle="$t('playerDetail.finishingMap')"></ChartExportLinksModal>
    <Tour v-if="currentUser.showTour" name="teamBeeswarmTour" :steps="tourSteps" />
  </v-container>
</template>

<script>
import * as d3 from "d3";
import Dictionary from '../../dictionary';
import GameService from '../../services/game/game.service';
import XGChart from '../base/XGChart';
import XGGoalChart from '../base/XGGoalChart';
import MediaModeForm from '../base/MediaModeForm';
import { exportSvg,downloadPng,copyAndAppendElement } from '../../utils/exportToPNG'
import PlayerAvatarMedia from '../player/PlayerAvatarMedia'
import DriblabSocialMedia from '../base/DriblabSocialMedia'
import SeasonService from '../../services/season.service';
import ChartExportLinksModal from '../base/ChartExportLinksModal';
import { v4 } from 'uuid';
import UserChartService from '../../services/user-chart.service';
import DocumentService from '../../services/document.service';
import {userHasRole} from '../../utils/functions';
import UserService from '../../services/user.service';
import TeamRadarService from "@/services/team/teamRadar.service";
import Tour from '../base/Tour';
import AreaSelectorModal from "../modals/AreaSelectorModal.vue";

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8081';

const API_URL = NODE_ENV === 'production' ? 'https://pro.driblab.com/embed-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/embed-chart/'

export default {
  name: 'TeamFinishingMap',
  components: {
    XGChart,
    XGGoalChart,
    MediaModeForm,
    PlayerAvatarMedia,
    DriblabSocialMedia,
    ChartExportLinksModal,
    Tour,
    AreaSelectorModal
  },
  props:{
    stackedView:{
      type: Boolean,
      required: false
    },
    chartId:{
      type: Number,
      default: 0
    },
    mediaModeCfg:{
      type: Object,
      required: false
    },
    mediaModeValue:{
      type: Boolean,
      required: false
    },
    teamInfo:{
      type: Object,
      required: false
    },
    checkboxCirclesInput:{
      type: Array,
      required: false
    },
    fullSize:{
      type: Boolean,
      required: false
    },
    noMarginTop:{
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      required: false
    },
    seasonIds:{
      type: Array,
      required: false,
      default: () => []
    },
    gameIds: {
      type: Array,
      required: false,
      default: () => []
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    darkMode(){
      return this.currentUser.darkMode || this.$vuetify.theme.dark
    },
    currentUserLanguage() {
      return this.language ? this.language : this.$store.getters["auth/language"];
    },
    allShotTypes () {
      return this.shotTypeModel.length === this.shotTypes.length
    },
    allShotStrategies () {
      // -3 is because 2 headers and 1 divider
      return this.shotStrategyModel.length === this.shotStrategies.length - 3
    },
    allBodyParts () {
      return this.bodyPartModel.length === this.bodyParts.length
    },
    teamId(){
      if(this.seasonDataSelectedModel && this.seasonDataSelectedModel.length){
        return _.find(this.teamSeasons,(sd) => sd.seasonId === this.seasonDataSelectedModel[0]).teamId;
      }
    },
    showGoalChart(){
      return _.some(this.teamSeasons,(s) => [2,3].includes(s.providerId));
    },
    lastSearchId() {
      return this.$store.state.auth.lastSearch;
    },
    allGames () {
      return this.gamesModel.length === this.gamesFiltered.length;
    },
    tourSteps() {
      return [
      {
          target: `#season-selection`,
          header: {
            title: this.$t("tours.teamFinishingMap.step1.title"),
          },
          content: this.$t("tours.teamFinishingMap.step1.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#own-opponent`,
          header: {
            title: this.$t("tours.teamFinishingMap.step2.title"),
          },
          content: this.$t("tours.teamFinishingMap.step2.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#shot-placement`,
          header: {
            title: this.$t("tours.teamFinishingMap.step3.title"),
          },
          content: this.$t("tours.teamFinishingMap.step3.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#shot-type`,
          header: {
            title: this.$t("tours.teamFinishingMap.step4.title"),
          },
          content: this.$t("tours.teamFinishingMap.step4.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },{
          target: `#filter-minutes`,
          header: {
            title: this.$t("tours.teamFinishingMap.step5.title"),
          },
          content: this.$t("tours.teamFinishingMap.step5.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#image-download`,
          header: {
            title: this.$t("tours.teamFinishingMap.step6.title"),
          },
          content: this.$t("tours.teamFinishingMap.step6.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#chart`,
          header: {
            title: this.$t("tours.teamFinishingMap.step7.title"),
          },
          content: this.$t("tours.teamFinishingMap.step7.message"),
          params: {
            placement: this.$vuetify.breakpoint.smAndDown ? "top" : "left",
            enableScrolling: false,
            highlight: true
          }
        }
      ]
    },
    hasPenalties() {
      return _.some(this.shots,(s) => s.strategyId === 9 && this.gamesModel.includes(s.gameId));
    },
    penalties() {
      return this.shots.filter((s) => s.strategyId === 9 && s.periodId !== 5 && this.gamesModel.includes(s.gameId));
    },
    penaltiesShootout() {
      return this.shots.filter((s) => s.strategyId === 9 && s.periodId === 5 && this.gamesModel.includes(s.gameId));
    }
  },
  data() {
    return {
      size: 0,
      margin: null,
      grounds: [{id: 1, name: this.$t("general.all")},
                {id: 2, name: this.$t("general.home")},
                {id: 3, name: this.$t("general.away")},
                {id: 4, name: this.$t('general.last') + ' ' + this.$t('playerRecruitment.xGames',{0:6})},
                {id: 5, name: this.$t('general.last') + ' ' + this.$t('playerRecruitment.xGames',{0:12})}],
      groundModel: 1,
      lineups: [],
      shots: [],
      filteredShots: [],
      playersWithShots: [],
      xgMap: 0,
      playerName: null,
      teamSeasons: [],
      seasonDataSelectedModel: [],
      filteredSeasons: [],
      shotTypes: [
        {id: 16, text: Dictionary[this.$i18n.locale]["finishingMap"]["goal"]},
        {id: 13, text: Dictionary[this.$i18n.locale]["finishingMap"]["missedShot"]},
        {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["savedShot"]},
        {id: 14, text: Dictionary[this.$i18n.locale]["finishingMap"]["shotOnPost"]},
        {id: 60, text: Dictionary[this.$i18n.locale]["finishingMap"]["missedChance"]}
      ],
      shotTypeModel: [13, 14, 15, 16, 60],
      shotStrategies: [
        {header: Dictionary[this.$i18n.locale]["finishingMap"]["openPlay"]},
        {id: 22, text: Dictionary[this.$i18n.locale]["finishingMap"]["regularPlay"]},
        {id: 23, text: Dictionary[this.$i18n.locale]["finishingMap"]["fastBreak"]},
        {id: 123, text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]["keeperThrowPlay"]},
        {id: 215, text: Dictionary[this.$i18n.locale]["finishingMap"]["individualPlay"]},
        {divider: true},
        {header: Dictionary[this.$i18n.locale]["finishingMap"]["setPiece"]},
        {id: 26, text: Dictionary[this.$i18n.locale]["finishingMap"]["freeKick"]},
        {id: 24, text: Dictionary[this.$i18n.locale]["finishingMap"]["indirectFreeKick"]},
        {id: 25, text: Dictionary[this.$i18n.locale]["finishingMap"]["fromCorner"]},
        {id: 124, text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]["gkKick"]},
        {id: 160, text: Dictionary[this.$i18n.locale]["finishingMap"]["throwInSetPiece"]},
        {id: 279, text: Dictionary[this.$i18n.locale]["videoHighlights"]["qualifierIds"]["279"]}
      ],
      shotStrategyModel: [22, 23, 215, 24, 25, 26, 160, 123, 124, 279],
      areaModel: ['goalArea', 'boxLeft', 'boxCenter', 'boxRight', 'outBoxDeepLeft', 'outBoxDeepRight', 'outBoxLeft',
        'outBoxCentreLeft', 'outBoxCentre', 'outBoxCentreRight', 'outBoxRight', 'left35', 'centreLeft35', 'centre35',
        'centreRight35', 'right35'],
      goalAreaModel: ['highLeft', 'highCenter', 'highRight', 'lowLeft', 'lowCenter', 'lowRight', 'outHighLeft',
        'high', 'outHighRight', 'closeHighLeft', 'closeHigh', 'closeHighRight', 'closeLeft', 'closeRight'],
      bodyParts: [
        {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["head"]},
        {id: 72, text: Dictionary[this.$i18n.locale]["finishingMap"]["leftFooted"]},
        {id: 20, text: Dictionary[this.$i18n.locale]["finishingMap"]["rightFooted"]},
        {id: 21, text: Dictionary[this.$i18n.locale]["finishingMap"]["otherBodyPart"]}
      ],
      bodyPartModel: [15, 20, 21, 72],
      minutes: [0, 90],
      checkboxCircles: ['circles'],
      showShotOptions: this.$vuetify.breakpoint.smAndDown ? false : true,
      rangeMinutes: [0,90],
      mediaMode: false,
      mediaModeFields: [
        {type:"text",label:"mediaMode.upperText",key:"upperText"},
        {type:"number",label:"mediaMode.upperTextFontSize",key:"upperTextFontSize"},
        {type:"radio",label:"mediaMode.upperTextFontWeight",key:"upperTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"text",label:"mediaMode.lowerText",key:"lowerText"},
        {type:"number",label:"mediaMode.lowerTextFontSize",key:"lowerTextFontSize"},
        {type:"radio",label:"mediaMode.lowerTextFontWeight",key:"lowerTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"color",label:"mediaMode.borderColor",key:"borderColor"},
        {type:"color",label:"mediaMode.homeFillColor",key:"homeFillColor"},
        {type:"color",label:"mediaMode.homeBorderColor",key:"homeBorderColor"},
        {type:"color",label:"mediaMode.awayFillColor",key:"awayFillColor"},
        {type:"color",label:"mediaMode.awayBorderColor",key:"awayBorderColor"},
        {type:"color",label:"mediaMode.bgColor",key:"bgColor"},
        {type:"color",label:"mediaMode.textColor",key:"textColor"},
        {type:"number",label:"mediaMode.avatarLineLength",key:"lineLength",force:true},
        {type:"number",label:"mediaMode.avatarLineWeight",key:"lineWeight",force:true},
        {type:"number",label:"mediaMode.avatarSize",key:"avatarSize",force:true},
        {type:"image",label:"mediaMode.face",key:"face"},
        {type:"switch",label:"mediaMode.socialMedia",key:"socialMedia"},
        {type:"number",label:"mediaMode.socialMediaFontSize",key:"socialMediaFontSize",force:true},
        {type:"radio",label:"mediaMode.socialMediaFontWeight",key:"socialMediaFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}],force:true},
        {type:"image",label:"mediaMode.sponsor",key:"sponsor",force:true,aspectRatio:16/9,imageRestriction:'none',resizable:true,stencilSize:{width:300,height:300}}
      ],
      chartSize: null,
      avatarSize: null,
      mediaModeFlags: {borderColor:null,bgColor:null,upperText:null,lowerText:null,socialMedia:null,textColor: null,homeFillColor:null,homeBorderColor:null,awayFillColor:null,awayBorderColor:null,face:null},
      mediaModeData: {borderColor:"#3366FF",bgColor:"#ffffff0",upperText:null,lowerText:null,socialMedia:true,textColor:"#000000"
        ,homeFillColor:"#ffffff",homeBorderColor:"#000000",awayFillColor:"#ffffff",awayBorderColor:"#000000",face:{},upperTextFontWeight:"900",lowerTextFontWeight:"400",
        socialMediaFontWeight:"400",socialMediaFontSize:"14",sponsor:{}},
      selectedTab: "topView",
      loadingExport: false,
      boxesPercentageModel: "shots",
      shotsModel:"team",
      games: [],
      gamesFiltered: [],
      gamesModel: [],
      mapType: 'finishingMap',
      showPenalties: false,
      showShootoutPenalties: false,
      showAllInfoInBoxes: false
    };
  },
  watch:{
    "$refs.XGMapInstance": function(newValue,oldValue){
      this.updateShots();
    },
    "mediaMode": function(newVal, oldVal) {
      if(!this.stackedView){
        if(!this.mediaMode){
          this.mediaModeData =  {borderColor:"#3366FF",bgColor:"#ffffff0",upperText:null,lowerText:null,socialMedia:true,textColor:"#000000",
          homeFillColor:"#ffffff",homeBorderColor:"#000000",awayFillColor:"#ffffff",awayBorderColor:"#000000",face:{},upperTextFontWeight:"900",
          lowerTextFontWeight:"400",socialMediaFontWeight:"400",socialMediaFontSize:"14",sponsor:{}}
        }
        this.mediaModeData.upperText = this.teamInfo.teamName;
        this.mediaModeData.bgColor = this.mediaMode ? '#ffffff' : '#ffffff0';
        this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${this.teamInfo.teamId}.png`;
        this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`;
        this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
        this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      }
    },
    "mediaModeCfg":function(newVal,oldVal){
      if(_.size(_.keys(newVal))){
        this.onMediaModeDataChange(newVal);
      }
    },
    "mediaModeValue":function(newVal,oldVal){
      if(!_.isEqual(newVal,oldVal)){
        this.mediaMode = newVal
      }
    }
  },
  mounted: async function() {
    if(this.checkboxCirclesInput){
      this.checkboxCircles = this.checkboxCirclesInput;
    }

    window.addEventListener("resize", this.onWindowResize);

    this.mediaMode = this.stackedView ? this.mediaModeValue : (this.currentUser.mediaMode || this.currentUser.clientType === 'Media');

    this.size = this.stackedView ? this.$refs.chart.clientWidth * 0.9 : this.$refs.chart.clientWidth * 0.75; // minus padding normal
    this.margin = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };

    let seasonsData = await SeasonService.getRadarSeasonsOfTeam(this.teamInfo.teamId);
    this.teamSeasons = seasonsData.data;
    this.filteredSeasons = seasonsData.data.slice(0, 1);
    
    if(this.seasonIds.length > 0){
      this.seasonDataSelectedModel = this.seasonIds;
    }else{
      // Default season : Regular season order by last match date desc
      const regularSeasonsSorted = this.teamSeasons
                          .filter(ts => ts.regular)
                          .sort((a,b) => b.lastMatchDate - a.lastMatchDate);

      this.seasonDataSelectedModel = [regularSeasonsSorted.length > 0 ? regularSeasonsSorted[0].seasonId : this.teamSeasons[0].seasonId];
    }
    
    await this.loadGamesBySeasons();
    await this.loadShots();

    this.updateMins();
    this.minutes = this.rangeMinutes;
    this.updateShots();
    this.mediaModeData.upperText = this.teamInfo.teamName;
    this.mediaModeData.lowerText = this.$t("playerDetail.finishingMap");
    this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${this.teamInfo.teamId}.png`;
    this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`;
    this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
    this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
    setTimeout(() => {
      UserService.putLastSearchRendered({id:this.lastSearchId});
    },250)
  },
  created() {
  },
  methods: {
    onWindowResize(e,force = false) {
      setTimeout(() => {
        force = force || (e && e.type === "resize");
        if(this.$refs.chart){
          this.size = this.stackedView ? this.$refs.chart.clientWidth * 0.9 : this.$refs.chart.clientWidth * 0.75;
        }
        if(this.$refs.xgChart){
          this.$refs.xgChart.printD3(force)
        }
        if(this.$refs.playerAvatarMediaRef){
          this.$refs.playerAvatarMediaRef.printD3(force)
        }
        if(this.$refs.driblabSocialMediaRef){
          this.$refs.driblabSocialMediaRef.printD3(force)
        }
        this.$forceUpdate();
      }, 200)
    },
    toggleGames () {
      this.$nextTick(() => {
        if (this.allGames)
          this.gamesModel = []
        else {
          this.gamesModel = this.gamesFiltered.slice().map(g => g.gameId);
        }
      })
    },
    filterGames(){
      switch (this.groundModel) {
        //All
        case 1:
          this.gamesFiltered = this.games;
          break;
        //Home
        case 2:
          this.gamesFiltered = this.games.filter(g => g.homeTeam);
          break;
        //Away
        case 3:
          this.gamesFiltered = this.games.filter(g => !g.homeTeam);
          break;
        case 4:
        case 5:
          this.gamesFiltered = this.games.slice(0, this.groundModel === 4 ? 6 : 12);
          break;
        default:
          this.gamesFiltered = this.games;
      }
      this.gamesModel = this.gamesFiltered.map(g => g.gameId);
    },
    async onSelectChange(){
      this.filterGames();
      this.updateShots();
    },
    async loadGamesBySeasons() {
      let gamesResponse = await TeamRadarService.getGamesOfTeamBySeasons(this.teamInfo.teamId, this.seasonDataSelectedModel);
      this.games = gamesResponse.data;
      this.filterGames();
    },
    shotsInArea(shots) {
      return shots
        .filter(s => this.areaModel.includes('goalArea') || !(s.x >= 94.2 && s.y >= 36.8 && s.y <= 63.2))
        .filter(s => this.areaModel.includes('boxRight') || !(s.x >= 83 && s.y >= 21.1 && s.y < 36.8))
        .filter(s => this.areaModel.includes('boxCenter') || !(s.x >= 83 && s.x < 94.2 && s.y >= 36.8 && s.y <= 63.2))
        .filter(s => this.areaModel.includes('boxLeft') || !(s.x >= 83 && s.y > 63.2 && s.y <= 78.9))
        .filter(s => this.areaModel.includes('outBoxDeepRight') || !(s.x >= 83 && s.y < 21.1))
        .filter(s => this.areaModel.includes('outBoxDeepLeft') || !(s.x >= 83 && s.y > 78.9))
        .filter(s => this.areaModel.includes('outBoxRight') || !(s.x >= 65 && s.x < 83 && s.y < 21.1))
        .filter(s => this.areaModel.includes('outBoxCentreRight') || !(s.x >= 65 && s.x < 83 && s.y >= 21.1 && s.y <= 35.5))
        .filter(s => this.areaModel.includes('outBoxCentre') || !(s.x >= 65 && s.x < 83 && s.y > 35.5 && s.y <= 64.4))
        .filter(s => this.areaModel.includes('outBoxCentreLeft') || !(s.x >= 65 && s.x < 83 && s.y > 64.4 && s.y <= 78.9))
        .filter(s => this.areaModel.includes('outBoxLeft') || !(s.x >= 65 && s.x < 83 && s.y > 78.9))
        .filter(s => this.areaModel.includes('right35') || !(s.x >= 50 && s.x < 65 && s.y < 21.1))
        .filter(s => this.areaModel.includes('centreRight35') || !(s.x >= 50 && s.x < 65 && s.y >= 21.1 && s.y <= 35.5))
        .filter(s => this.areaModel.includes('centre35') || !(s.x >= 50 && s.x < 65 && s.y > 35.5 && s.y <= 64.4))
        .filter(s => this.areaModel.includes('centreLeft35') || !(s.x >= 50 && s.x < 65 && s.y > 64.4 && s.y <= 78.9))
        .filter(s => this.areaModel.includes('left35') || !(s.x >= 50 && s.x < 65 && s.y > 78.9))
    },
    shotsInGoalArea(shots) {
      return shots
        .filter(s => this.goalAreaModel.includes('highLeft') || !(s.z_mouth >= 20 && s.z_mouth <= 42 && s.y1 >= 51.8 && s.y1 < 55.8))
        .filter(s => this.goalAreaModel.includes('highCenter') || !(s.z_mouth >= 20 && s.z_mouth <= 42 && s.y1 >= 48.2 && s.y1 < 51.8))
        .filter(s => this.goalAreaModel.includes('highRight') || !(s.z_mouth >= 20 && s.z_mouth <= 42 && s.y1 >= 44.2 && s.y1 < 48.2))
        .filter(s => this.goalAreaModel.includes('lowLeft') || !(s.z_mouth >= 0 && s.z_mouth <= 20 && s.y1 >= 51.8 && s.y1 < 55.8))
        .filter(s => this.goalAreaModel.includes('lowCenter') || !(s.z_mouth >= 0 && s.z_mouth <= 20 && s.y1 >= 48.2 && s.y1 < 51.8))
        .filter(s => this.goalAreaModel.includes('lowRight') || !(s.z_mouth >= 0 && s.z_mouth <= 20 && s.y1 >= 44.2 && s.y1 < 48.2))
        .filter(s => this.goalAreaModel.includes('outHighLeft') || !(s.z_mouth >= 60 && s.z_mouth <= 92.5 && s.y1 >= 55.8 && s.y1 < 61))
        .filter(s => this.goalAreaModel.includes('high') || !(s.z_mouth >= 60 && s.z_mouth <= 92.5 && s.y1 >= 44.2 && s.y1 < 55.8))
        .filter(s => this.goalAreaModel.includes('outHighRight') || !(s.z_mouth >= 60 && s.z_mouth <= 92.5 && s.y1 >= 39 && s.y1 < 44.2))
        .filter(s => this.goalAreaModel.includes('closeHighLeft') || !(s.z_mouth >= 40 && s.z_mouth <= 60 && s.y1 >= 55.8 && s.y1 < 61))
        .filter(s => this.goalAreaModel.includes('closeHigh') || !(s.z_mouth >= 40 && s.z_mouth <= 60 && s.y1 >= 44.2 && s.y1 < 55.8))
        .filter(s => this.goalAreaModel.includes('closeHighRight') || !(s.z_mouth >= 40 && s.z_mouth <= 60 && s.y1 >= 39 && s.y1 < 44.2))
        .filter(s => this.goalAreaModel.includes('closeLeft') || !(s.z_mouth >= 0 && s.z_mouth <= 40 && s.y1 >= 55.8 && s.y1 < 61))
        .filter(s => this.goalAreaModel.includes('closeRight') || !(s.z_mouth >= 0 && s.z_mouth <= 40 && s.y1 >= 39 && s.y1 < 44.2))
    },
    async loadShots(){
      let shotsData = await GameService.getXGShotsOfTeam(this.teamInfo.teamId,this.seasonDataSelectedModel);
      this.shots = shotsData.data.map(s => {
        if (s.strategyId === 9) {
          //Adjust penalty shots' values
          s.xG = [15, 16].includes(s.eventTypeId) ? 0.765 : 0;
          s.xgOnTarget = [15, 16].includes(s.eventTypeId) ? 0.765 : 0;
          s.y = 50;
          s.x = 88.5;
        };
        return s;
      });
    },
    updateShots() {
      this.updateMins();
      this.filteredSeasons = this.teamSeasons
        .filter(s => this.seasonDataSelectedModel.includes(s.seasonId));
      this.filteredShots = this.filterShots();

      let filteredShotsByxG = _.orderBy(this.filteredShots,['xG'],['desc']);
      this.filteredShots = _.orderBy(this.filteredShots,['periodId','min','sec'],['asc','asc','asc']);
      this.$emit("filteredShots", filteredShotsByxG);
      this.xgMap++;

    },
    toggleShotStrategies () {
      this.$nextTick(() => {
        if (this.allShotStrategies) {
          this.shotStrategyModel = []
        } else {
          //Need filter beacause shotStrategies array has 10 items, 7 strategies and 3 other items (2 headers and 1 divider)
          this.shotStrategyModel = this.shotStrategies.filter(function(sS){ return sS.id ? true : false }).map(function(sS) { return sS.id; })
        }
        this.updateShots();
      })
    },
    toggleShotTypes () {
      this.$nextTick(() => {
        if (this.allShotTypes) {
          this.shotTypeModel = []
        } else {
          this.shotTypeModel = this.shotTypes.map(function(p) { return p.id; })
        }
        this.updateShots();
      })
    },
    toggleBodyPart () {
      this.$nextTick(() => {
        if (this.allBodyParts) {
          this.bodyPartModel = []
        } else {
          this.bodyPartModel = this.bodyParts.map(function(p) { return p.id; })
        }
        this.updateShots();
      })
    },
    prepareSvgForMedia(){
      let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
      let heightAccum = 0;
      let yOffset = 120;
      parent.style.background = this.mediaModeData.bgColor;

      //COPY HEADER
      copyAndAppendElement(parent,document.querySelector(`#playerAvatarMedia${this.teamInfo.teamId}-${this.chartId}SVG`),100,0)
      heightAccum += this.selectedTab === 'topView' ? this.avatarSize.height : this.avatarSize.height * 1.25;
      copyAndAppendElement(parent,document.querySelector(`#pitchXG${this.teamInfo.teamId}-${this.chartId}SVG`),100,heightAccum)
      heightAccum += this.chartSize.height;
      if(this.mediaModeData.socialMedia && !this.stackedView){
        copyAndAppendElement(parent,document.querySelector(`#driblabSocialMedia${this.teamInfo.teamId}-${this.chartId}SVG`),100,heightAccum)
        heightAccum += 50;
      }

      let parentWidth = this.stackedView ? this.size : this.chartSize.width;
      parentWidth = this.selectedTab === 'topView' ? parentWidth : parentWidth * 1.25
      parent.setAttribute("width",parentWidth);
      parent.setAttribute("height",heightAccum);
      return parent;
    },
    saveAsPNG() {
      if(this.mediaMode){
        downloadPng(this.prepareSvgForMedia(), "Driblab_XGMap_" + this.teamInfo.teamName.replace(' ','_') + ".png");
      }else{
        let svg = d3.select(`#pitchXG${this.teamInfo.teamId}-${this.chartId}`)
          .select("svg").node()
        downloadPng(svg, "Driblab_XGMap_" + this.teamInfo.teamName.replace(' ','_') + ".png");
      }
    },
    saveAsSVG() {
      if(this.mediaMode){
        exportSvg(this.prepareSvgForMedia(), "Driblab_XGMap_" + this.teamInfo.teamName.replace(' ','_'));
      }else{
        let svg = d3.select(`#pitchXG${this.teamInfo.teamId}-${this.chartId}`)
          .select("svg").node()
        exportSvg(svg, "Driblab_XGMap_" + this.teamInfo.teamName.replace(' ','_'));
      }
    },
    getElementToExport(){
      if(this.mediaMode){
        return this.prepareSvgForMedia();
      }else{
        let svg = d3.select(`#pitchXG${this.teamInfo.teamId}-${this.chartId}`)
          .select("svg").node()
       return svg;
      }
    },
    updateMins(){
      this.rangeMinutes = [0,_.chain(this.shots).map(s => s.min).max().value()];
      this.rangeMinutes[1] = this.rangeMinutes[1] < 90 ? 90 : this.rangeMinutes[1];
    },
    filterShots(includeMins = true){
      const minutesMaxFilter = this.minutes[1];
      let filtered;

      if(this.gameIds.length){
        filtered = this.shots.filter(s => this.gameIds.includes(s.gameId));
      }else{
        filtered = this.shots
          .filter(s =>  this.gamesModel.includes(s.gameId))
          .filter(s => this.shotTypeModel.includes(s.eventTypeId))
          .filter(s => this.shotStrategyModel.includes(s.strategyId))
          .filter(s => this.bodyPartModel.includes(s.bodyPartId));
      }

      if(includeMins){
        filtered = filtered.filter(s => s.min >= this.minutes[0] && s.min <= minutesMaxFilter);
      }

      if(this.selectedTab === 'topView'){
        filtered = this.shotsInArea(filtered);
      }else if(this.selectedTab === 'frontView'){
        filtered = this.shotsInGoalArea(filtered);
      }

      //Add penalties if they are selected
      if (this.showPenalties) filtered = filtered.concat(this.penalties.filter(p => this.gamesModel.includes(p.gameId)));
      if (this.showShootoutPenalties) filtered = filtered.concat(this.penaltiesShootout.filter(p => this.gamesModel.includes(p.gameId)));

      filtered = filtered.filter(s => this.shotsModel === 'team' ? (s.teamId === this.teamInfo.teamId && !s.ownGoal) || (s.teamId != this.teamInfo.teamId && s.ownGoal)
      : (s.teamId != this.teamInfo.teamId && !s.ownGoal) || (s.teamId === this.teamInfo.teamId && s.ownGoal));

      return filtered;
    },
    onChartSizeChange(size){
      this.chartSize = size;
      this.avatarSize = {
        width: size.width,
        height: size.height / 4.75
      }
    },
    onMediaModeDataChange(event){
      this.mediaModeData = event;
      setTimeout(() => {this.onWindowResize(null,this.mediaModeData.force);},666)
    },
    onTypeChange(tab){
      let availableSeasons = this.teamSeasons.filter(s => [2,3].includes(s.providerId) || tab === 'topView')
      this.seasonDataSelectedModel = this.seasonDataSelectedModel.filter(sId => availableSeasons.map(s => s.seasonId).includes(sId));
      this.postSearch();
      this.updateShots();
    },
    async postSearch(){
      const authorized = true;
      const category ='team';
      let urlId = this.playerId;
      //maps means FinishinMap, don't rename because ToolEnum url
      const tool = 'maps';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      const metaInfo = JSON.stringify({tab:this.selectedTab});
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser,metaInfo);
      UserService.putLastSearchRendered({category,tool,id:searchResponse.data})
    },
    async onGenerateIFrameClick(){
      this.loadingExport = true;
      let elToExport = this.getElementToExport();
      let key = v4();
      key = `${key}.json`;
      let chartObject = {
        awsKey:key,
        tool: 'finishing-map',
        category: 'team',
        componentId: this.teamInfo.teamId,
        width: elToExport.getAttribute("width"),
        height: this.mediaMode ? elToExport.getAttribute("width") * 0.9925 : elToExport.getAttribute("width") * 0.806
      }
      let postResponse = await UserChartService.postChart(chartObject)
      let chartEntity = postResponse.data;

      this.$refs.chartExportLinksModalRef.open(chartEntity);
      this.loadingExport = false;

      let urlResponse = await UserChartService.getUploadURL(chartEntity.id,key);
      let uploadUrl = urlResponse.data;
      var jsonse = JSON.stringify({
        margin: this.margin,
        size: Number(chartEntity.width),
        height: Number(chartEntity.height),
        shots: this.filteredShots,
        circlesAndBoxes: this.checkboxCircles,
        playerSeasonData:this.filteredSeasons,
        language:this.currentUserLanguage,
        mediaModeData: this.mediaModeData,
        mediaMode: this.mediaMode,
        playerAvatarKey: 0,
        key: this.xgMap,
        socialMediaKey: 2,
        type: this.type,
        id: `${this.teamInfo.teamId}-${this.chartId}`,
        teamMode: true,
        teamName: this.teamInfo.teamName,
        team:this.teamInfo,
        selectedTab: this.selectedTab,
        chartType:"finishing-map"
      });

      var blob = new Blob([jsonse], {type: "application/json"});
      // let blob = exportSvgToFile(elToExport);
      let uploadResponse = await DocumentService.upload(uploadUrl,blob);
      this.postSearchChart(chartEntity)
    },
    async postSearchChart(chart){
      const authorized = true;
      let metaInfo = null;
      let category = "team";
      let urlId = this.teamInfo.teamId;

      metaInfo = JSON.stringify({
        link: `${API_URL}${chart.id}/key/${chart.awsKey}/compId/${chart.componentId}/catId/${chart.categoryId}/tId/${chart.toolId}`
      });
      const tool = 'embed';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);
      UserService.putLastSearchRendered({category,tool,id:searchResponse.data})
    },
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
    onLoaded(event){
      //Emit when is loaded
      this.$emit("loaded", event);
    },
    async onSeasonChange(){
      if (this.seasonDataSelectedModel.length) {
        await this.loadGamesBySeasons();
        await this.loadShots();
        this.updateShots();
      } else {
        this.seasonDataSelectedModel = [];
      };
    },
    onSelectAreaClick(){
      this.$refs.areaSelectorModalRef.open();
    },
    onAreaSelectorConfirm(event){
      if (event && event.codes && event.codes.length > 0) this.areaModel = event.codes;
      else this.areaModel = [];
      this.updateShots();
    },
    onSelectGoalAreaClick(){
      this.$refs.goalAreaSelectorModalRef.open();
    },
    onGoalAreaSelectorConfirm(event){
      if (event && event.codes && event.codes.length > 0) this.goalAreaModel = event.codes;
      else this.goalAreaModel = [];
      this.updateShots();
    }
  },
  destroyed() {
    this.shots = null;
    d3.selectAll('.tooltip').remove();
    window.removeEventListener("resize", this.onWindowResize);
  }
};
</script>

<style >
  body > div.tooltip {
    font-family: 'NeueMontreal';
    pointer-events: none;
    position: absolute;
    background: none repeat scroll 0 0 #ffffff;
    padding: 5px 10px 5px 10px;
    border-radius: 4px;
    text-align: center;
    display: none;
    line-height: 1.5;
    color: #081F2C;
    box-shadow: 0px 3px 9px rgba(0, 0, 0, .15);
  }

  body > div.tooltip:after {
    box-sizing: border-box;
    display: block;
    width: 100%;
    line-height: 2.8;
    color: #000000;
    content: "\25BC";
    text-align: center;
  }
  v-messages {
    height: 6px;
  }

</style>



// WEBPACK FOOTER //
// src/views/team/TeamFinishingMap.vue